import _toConsumableArray from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { globalThis } from "./utils/server-safe-globals.js";
import { MediaChromeRange } from "./media-chrome-range.js";
import { MediaUIAttributes, MediaUIEvents } from "./constants.js";
import { nouns } from "./labels/labels.js";
import { getBooleanAttr, getNumericAttr, getStringAttr, setBooleanAttr, setNumericAttr, setStringAttr } from "./utils/element-utils.js";
var DEFAULT_VOLUME = 1;

var toVolume = function toVolume(el) {
  if (el.mediaMuted) return 0;
  return el.mediaVolume;
};

var formatAsPercentString = function formatAsPercentString(_ref) {
  var value = _ref.value;
  return "".concat(Math.round(value * 100), "%");
};

var MediaVolumeRange = /*#__PURE__*/function (_MediaChromeRange) {
  _inherits(MediaVolumeRange, _MediaChromeRange);

  var _super = _createSuper(MediaVolumeRange);

  function MediaVolumeRange() {
    var _this;

    _classCallCheck(this, MediaVolumeRange);

    _this = _super.call(this);

    _this.range.addEventListener("input", function () {
      var detail = _this.range.value;
      var evt = new globalThis.CustomEvent(MediaUIEvents.MEDIA_VOLUME_REQUEST, {
        composed: true,
        bubbles: true,
        detail: detail
      });

      _this.dispatchEvent(evt);
    });

    return _this;
  }

  _createClass(MediaVolumeRange, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(MediaVolumeRange.prototype), "connectedCallback", this).call(this);

      this.range.setAttribute("aria-label", nouns.VOLUME());
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      _get(_getPrototypeOf(MediaVolumeRange.prototype), "attributeChangedCallback", this).call(this, attrName, oldValue, newValue);

      if (attrName === MediaUIAttributes.MEDIA_VOLUME || attrName === MediaUIAttributes.MEDIA_MUTED) {
        this.range.valueAsNumber = toVolume(this);
        this.range.setAttribute("aria-valuetext", formatAsPercentString(this.range));
        this.updateBar();
      }
    }
  }, {
    key: "mediaVolume",
    get: function get() {
      return getNumericAttr(this, MediaUIAttributes.MEDIA_VOLUME, DEFAULT_VOLUME);
    },
    set: function set(value) {
      setNumericAttr(this, MediaUIAttributes.MEDIA_VOLUME, value);
    }
  }, {
    key: "mediaMuted",
    get: function get() {
      return getBooleanAttr(this, MediaUIAttributes.MEDIA_MUTED);
    },
    set: function set(value) {
      setBooleanAttr(this, MediaUIAttributes.MEDIA_MUTED, value);
    }
  }, {
    key: "mediaVolumeUnavailable",
    get: function get() {
      return getStringAttr(this, MediaUIAttributes.MEDIA_VOLUME_UNAVAILABLE);
    },
    set: function set(value) {
      setStringAttr(this, MediaUIAttributes.MEDIA_VOLUME_UNAVAILABLE, value);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaVolumeRange), "observedAttributes", this)), [MediaUIAttributes.MEDIA_VOLUME, MediaUIAttributes.MEDIA_MUTED, MediaUIAttributes.MEDIA_VOLUME_UNAVAILABLE]);
    }
  }]);

  return MediaVolumeRange;
}(MediaChromeRange);

if (!globalThis.customElements.get("media-volume-range")) {
  globalThis.customElements.define("media-volume-range", MediaVolumeRange);
}

var media_volume_range_default = MediaVolumeRange;
export { media_volume_range_default as default };